// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__1kDig","ranges":"BmiRanges_ranges__1N9ZT"};